/** Default site copilot for AgentCy Labs (Aida). */
export const DEFAULT_COPILOT = {
  label: 'Aida Chat',
  value: 'da9fc8a8-ce3d-4da1-bfb9-245e0102a3cc',
  icon: 'https://feedalabs-agent-icon.s3.eu-north-1.amazonaws.com/aida-circle_11a4c8f4973a42fdae9d45d1da957d39.png',
  mode: 'agent',
};

export const DEFAULT_COPILOT_ID = DEFAULT_COPILOT.value;
export const DEFAULT_COPILOT_NAME = DEFAULT_COPILOT.label;
export const DEFAULT_COPILOT_ICON = DEFAULT_COPILOT.icon;

export function isDefaultCopilot(agent) {
  if (!agent) return false;
  const id = agent.value ?? agent.id ?? agent.agent_id;
  const name = (agent.label || agent.agent_name || '').toLowerCase().trim();
  return String(id) === DEFAULT_COPILOT_ID || name === 'aida' || name === 'aida chat';
}

export function findDefaultCopilot(agents) {
  if (!agents?.length) return null;
  return (
    agents.find(a => String(a.id ?? a.agent_id) === DEFAULT_COPILOT_ID) ||
    agents.find(a => {
      const name = (a.agent_name || '').toLowerCase().trim();
      return name === 'aida' || name === 'aida chat';
    }) ||
    null
  );
}

/** Map an API agent to a select/context option; brand the default as Aida Chat. */
export function toDefaultAwareAgentOption(agent) {
  if (!agent) return null;
  const value = agent.id ?? agent.agent_id ?? agent.value;
  const isDefault = String(value) === DEFAULT_COPILOT_ID || isDefaultCopilot(agent);
  if (isDefault) {
    return {
      label: DEFAULT_COPILOT_NAME,
      value: DEFAULT_COPILOT_ID,
      icon: DEFAULT_COPILOT_ICON,
      mode: 'agent',
    };
  }
  return {
    label: agent.agent_name || agent.label,
    value,
    icon: agent.icon ?? null,
    mode: agent.mode || 'agent',
  };
}
